<template>
 <div>
  <v-nav nav-class="purple darken-4">
    <a href="https://pedidos.guepardos.co/" class="brand-logo" slot="logo">
      <img class="responsive-img" src="../assets/logo-nuevo.png" width="55" style="padding-top: 5px;" />
    </a>
    <ul class="left hide-on-small-only">
      <li>
        <a href="https://pedidos.guepardos.co/" style="padding-left:75px; font-size:29px;">Guepardos</a>
      </li>
    </ul>
    <v-side-nav id="side" slot="side-nav"></v-side-nav>
  </v-nav>
  <div class="row">
    <div class="col s12 card-content valign center">
      <img class="responsive-img" src="../assets/logo-nuevo.png" width="300"/>
    </div> 
    <div class="col s12"><h1 class="center-align">¡El servicio que intentas rastrear no se encuentra disponible!</h1></div>
    <h3 class="center-align"><a style="text-decoration: underline;" href="https://pedidos.guepardos.co/">Ir a Guepardos.co</a></h3>
  </div>
 </div>
</template>

<script>
export default {
  name: 'home'
}
</script>

<style>
.purple.darken-4 {
    background-color: #410099 !important;
}
</style>  


// WEBPACK FOOTER //
// Home.vue?c5b3e93e